import ShortcutManager from './ShortcutManager.connect';

export default ShortcutManager;
